export default {
  'profile.updatesuccess': '個人情報が最新になりました',
  'profile.insertsuccess': '個人情報が登録されました',
  'profile.profile': '個人情報',
  'profile.search': '検索',
  'profile.oldpassword': '旧パスワード',
  'profile.newpassword': '新パスワード',
  'profile.logo': 'ロゴ',
  'profile.workinghours': '営業時間',
  'profile.nationalcardfile': 'IDカードファイル',
  'profile.addfile': 'ファイルの追加',
  'profile.editinformation': 'プロファイル情報の編集',
  'profile.email': 'e-mail',
  'profile.weekdays': '平日',
  'profile.close': '閉じる',
  'profile.savechanges': '変更を保存',
  'profile.deleteconfirmation': '削除してもよろしいですか？',
  'profile.rolename': '役職名',
  'profile.register': '登録',
  'profile.delete': '削除',
  'profile.addemployee': '新しい従業員を追加',
  'profile.deleteemployee': '従業員を削除',
  'profile.cancel': 'キャンセル',
  'profile.number': '番号',
  'profile.fromtime': '何時から',
  'profile.totime': '何時まで',
  'profile.setworkinghours': '就業時間をセットしてください',
  'profile.phone': '電話',
  'profile.selectyear': '年を選んでください',
  'profile.selectmonth': '月を選んでください',
  'profile.selectday': '日を選んでください',
  'profile.address': '住所',
  'profile.companyname': '会社名',
  'profile.englishcompanyname': '会社名（英語で）',
  'profile.persiancompanyname': '現地会社名',
  'profile.removeaddress': '住所を削除',
  'profile.moreaddress': '住所を追加',
  'profile.removephone': '電話番号を削除',
  'profile.addphone': '電話番号を追加',
  'profile.registercode': 'レジスターコード',
  'profile.managername': 'マネージャー／代理人名（必須）',
  'profile.businessmanagername': 'マネージャー名（必須）',
  'profile.type': 'ビジネスタイプ（必須）',
  'profile.businesstype': 'ビジネスタイプ（必須）',
  'profile.licensefile': 'ライセンスファイル',
  'profile.updatepassword': 'パスワードを最新にして次に進んでください',
  'profile.editprofile': 'ビジネスプロファイルの編集',
  'profile.individualprofile': 'プロファイルの編集',
  'profile.inviteemployee': '従業員を招待',
  'profile.change': '変更を保存',
  'profile.firstname': '名',
  'profile.lastname': '姓',
  'profile.mobile': '携帯',
  'profile.nationalcode': 'ID番号',
  'profile.password': 'パスワード',
  'profile.username': 'ユーザーネーム',
  'profile.username/email': 'ユーザーネーム／e-mail',
  'profile.gender': '性別',
  'profile.birthdate': '生年月日',
  'profile.selectavatar': 'アバターを選択',
  'profile.adminitstrator': '管理者',
  'profile.book/reserve': 'オーダー',
  'profile.changepassword': 'パスワードの変更',
  'profile.editpersonalprofile': 'プロファイルの変更',
  'profile.onlinesupport': 'オンラインサポート',
  'profile.employee': '従業員',
  'profile.addprofile': '新しいビジネスプロファイルの追加',
  'profile.addbusiness': 'ビジネスの追加',
  'profile.encompanyname': '会社名（英語で）（必須）',
  'profile.facompanyname': '現地会社名（必須）',
  'profile.myprofile': 'マイ　プロファイル',
  'profile.employeemanagement': '従業員管理',
  'profile.airlinequota': '航空会社の割り当て',
  'profile.signiture': '署名のプロファイル',
  'profile.addsigniture': '署名の保存',
  'profile.quotaadd': '完了しました',
  'profile.signout': 'ログアウト',
  'profile.signituresave': 'サインが保存されました',
  'profile.signitureerror': 'もう一度やり直してください',
  'profile.profiletype': 'プロファイルタイプを選択',
  'profile.profilsend':
    '確認のためプロファイルが送信されました。まもなく結果が表示されます',
  'profile.suspend': '一時停止',
  'profile.nationalid': 'ID番号（必須）',
  'profile.businessnationalid': 'ID番号',
  'profile.activitycode': 'アクティビティコード（必須）',
  'profile.economiccode': 'エコノミックコード（必須）',
  'profile.businessactivitycode': 'アクティビティコード',
  'profile.businesseconomiccode': 'エコノミックコード',
  'profile.choosegateway': 'ゲートウェイの選択',
  'profile.testconnection': '接続テスト',
  'profile.savesigniture': 'サインの保存',
  'profile.signitureping': '完了しました',
  'profile.country': '国名',
  'profile.city': '都市名',
  'profile.role': '役職',
  'profile.whoareyou': '誰ですか？',
  'profile.license': 'ライセンスを追加',
  'profile.removelicense': 'ライセンスを削除',
  'profile.addlicense': 'ライセンスを追加',
  'profile.viewlicense': 'ライセンスを表示する',
  'profile.walletremain': 'ウォレットは残ります',
  'profile.profileedit': 'プロファイル編集',
  'profile.licenses': 'ライセンス',
  'profile.licensetype': 'タイプ',
  'profile.upload': 'アップロード',
  'profile.completeprofilepoint':
    'ポイントの獲得にはプロファイルを完成させてください',
  'profile.licenseno': 'ライセンス番号',
  'profile.addresswithoutindex': '住所',
  'profile.phonewithoutindex': '電話番号',
  'profile.underprocess': '作業中',
  'profile.fullname': '姓名',
  'profile.airlinemarkup': 'エアラインのマークアップ',
  'profile.airlinename': '航空会社名',
  'profile.airlinetype': '航空会社のタイプ',
  'profile.quota': '売り上げシェア',
  'profile.markup': 'マークアップ',
  'profile.savequota': '売り上げシェアを保存',
  'profile.currency': '通貨',
  'profile.passportNumber': '旅券番号',
  'profile.userPointType': 'ユーザー',
  'profile.point': 'ポイント',
  'profile.savepoint': 'ポイントを保存',
  'profile.userpoint': 'ユーザーのポイント',
  'profile.subject': '件名',
  'profile.date': '割り当て日',
  'profile.totaluserpoint': 'ユーザーポイントの合計',
  'profile.viewdetails': '詳細表示',
  'profile.provider': 'プロバイダー',
  'profile.b2brequest': 'サービスリクエスト',
  'profile.language': '言語',
  'profile.department': '部門',
  'profile.adddetail': '詳細の追加（任意）',
  'profile.identityno': 'ID番号',
  'profile.gateway': 'ゲートウェイ',
  'profile.hi': 'こんにちは',
  'profile.status': '状態',
  'profile.approve': '承認',
  'profile.dissapprove': '不承認',
  'profile.pending': '保留',
  'profile.notexitstuser': 'このユーザーネームは登録されていません',
  'profile.selectrole': '役職と部門を選択してください',
  'profile.invitesuccessfully': '招待状が送付されました',
  'profile.description': '説明',
  'profile.filldescription': '説明を記入してください',
  'profile.dashboard': 'ダッシュボード',
  'profile.mydashboard': 'マイ　ダッシュボード',
  'profile.saleaccounting': 'セールレポート',
  'profile.profileaccounts': 'アカウント管理',
  'profile.commissionmanagement': 'ポイント管理',
  'profile.uploadlogo': '会社のロゴをアップロードしてください',
  'profile.uploadlicense': 'ライセンスをアップロードしてください',
  'profile.deleteprofile': 'プロファイルを削除',
  'profile.licensepic': 'ライセンスの写真',
  'profile.airlineCommission': '航空会社コミッション／マークアップ管理',
  'profile.errordelete': 'このレコードは削除できません',
  'profile.editverification': 'このプロファイルを編集しますか？',
  'profile.reference': 'エクスポーターのリファレンス',
  'profile.logotitle':
    '会社のロゴの編集には下記のオプションをクリックしてください。',
  'profile.invitedepartment': 'ご利用者様、あなたは次の役職で',
  'profile.inviteprofile': 'ビジネス プロファイルの部門に',
  'profile.inviterole': '招待されました。',
  'profile.invite': '招待状が届いています、ご確認ください',
  'profile.countercommission': 'カウンターコミッション',
  'profile.ownercommission': 'オーナーコミッション',
  'profile.bankaccounttype': '銀行口座のタイプ',
  'profile.newQuota': '新しい割り当て　',
  'profile.commission': 'プロファイルコミッション',
  'profile.addQuota': '追加の割り当て',
  'profile.customermanagement': 'カスタマー管理',
  'profile.active': '有効',
  'profile.disactive': '無効にする',
  'profile.Individual': '個人',
  'profile.bussiness': 'ビジネス',
  'profile.postalcode': '郵便番号',
  'profile.fax': 'ファックス',
  'profile.accountingcode': '会計コード',
  'profile.deletecustomer': 'カスタマーの削除',
  'profile.insertcustomer': 'カスタマーの挿入',
  'profile.updatecustomer': 'カスタマーのアップデート',
  'profile.both': '両方',
  'profile.reload': '再ロード',
  'profile.reloadfilter': '再ロードフィルター',
  'profile.isbusiness': 'ビジネス',
  'profile.isactive': 'アクティブ',
  'profile.name': '名前',
  'profile.registerdate': '登録日',
  'profile.chargewallet': 'ウォレットに入金',
  'profile.currentcredit': '現在のクレジット',
  'profile.amount': 'チャージ金額',
  'profile.chargecreditmessgae':
    '簡単、そして安全に購入するにはウォレットにチャージしましょう',
  'profile.credit': 'クレジット',
  'profile.paymentdate': '決済日',
  'profile.businessbooking': 'オーダー',
  'profile.gotpage': 'ウォレットチャージのページに戻る',
  'profile.notfound': 'レコードが見当たりません',
  'profile.message': 'メッセージ',
  'profile.pointtransaction': 'ポイントトランザクション',
  'profile.buypoints': '購入ポイント',
  'profile.mypoint': '私のポイント',
  'profile.wallet': 'ウォレット',
  'profile.chooseRole': '選択してください',
  'profile.mycredit': 'マイクレジット',
  'profile.departmentmanagement': '部門管理',
  'profile.customerphrase': '姓名／会計コード',
  'profile.enterusername': 'ご希望のユーザー名を記入してください',
  'profile.menucredit': 'クレジット',
  'profile.personalprofile': '個人のプロファイル',
  'profile.employeesearch': '名、姓、携帯番号で検索',
  'profile.gotowalletpage': 'ウォレットチャージのページに戻る',
  'profile.documentdescription': 'ドキュメントの説明',
  'profile.documentnumber': 'ドキュメント番号',
  'profile.registertime': '登録時間',
  'profile.price': '金額（イランリアル）',
  'profile.errorsecondpassword': '第２パスワードが一致しません',
  'profile.successsecondpassword': '第２パスワードが保存されました',
  'profile.insertinformation': 'インフォーメーションの挿入',
  'profile.businessprofile': 'ビジネスプロフィール',
  'profile.creditmanagement': '与信管理',
  'profile.affiliateMarketing': 'アフィリエイトマーケティング',
  'profile.account': 'アカウント',
  'profile.individual': '個人',
  'profile.business': '仕事',
  'profile.myfriends': '私の友人',
  'profile.viewCreditsAndWallets': 'クレジットとウォレットを表示する',
  'profile.employeeManagement': '従業員管理',
  'profile.customerManagement': '顧客管理',
  'profile.financialmanagement': '財務管理',
  'profile.messagedate': 'メッセージの日付',
  'profile.startMessagedate': 'メッセージ開始日',
  'profile.endMessagedate': '終了メッセージの日付',
  'profile.pointsremain': 'ポイントは残ります',
  'profile.messagedescription': 'メッセージの説明',
  'profile.startTravelDate': '旅行開始日',
  'profile.endTravelDate': '旅行日',
  'profile.upgradeYourPlan': 'プランをアップグレード',
  'profile.planCustomer': '顧客の計画',
  'profile.walletbalance': 'ウォレットの残高',
  'profile.bankreceipt': '銀行の領収書',
  'profile.online': 'オンライン',
  'profile.increasebalance': 'バランスを上げる',
  'profile.selectedbills': '選択された請求書',
  'profile.paymentbills': '支払い手形',
  'profile.employeeList': '従業員リスト',
  'profile.addEmployee': '従業員を追加',
  'profile.sendingInvitation': '招待状の送信',
  'profile.employee': '従業員',
  'profile.call': '電話',
  'profile.message': 'メッセージ',
  'profile.increaseOrEditCredentials': 'クレデンシャルを増やすか編集する',
  'profile.sendToGroup': 'グループに送信',
  'profile.theDesiredRole': '目的の役割',
  'profile.addDepartment': '部門の追加',
  'profile.employeeRole': '従業員の役割',
  'profile.moreDetails': '詳細',
  'profile.mehdiAbdollahiMehr': 'Mehdi Abdollahi Mehr',
  'profile.hiMessage': 'こんにちは、どこにいますか？',
  'profile.inWork': 'Inwork',
  'profile.addNew': '新規追加',
  'profile.reminding': 'リマインダー',
  'profile.participate': '参加',
  'profile.sportsInteractive': 'スポーツインタラクティブ ',
  'profile.team': 'チーム',
  'profile.tasks': 'タスク',
  'profile.chooseAnArtist': 'アーティストを選択してください',
  'profile.prepareForACallWithAClient': 'クライアントとの通話の準備',
  'profile.prepareAEKTemplateForTheClient':
    '「クライアント用のEKテンプレートを準備する」',
  'profile.prepareDetiledBrief':
    '「開発者と04:12の設計者向けに詳細な概要を準備する」',
  'profile.more': 'もっと',
  'profile.position': 'ポジション ',
  'profile.employeeInformation': '従業員情報',
  'profile.employeeRegistrationDate': '従業員登録日',
  'profile.creditAmount': 'クレジット金額',
  'profile.theCeilingOfEachPurchase': '各購入の上限',
  'profile.validityDuration': '有効期間',
  'profile.creditStatus': 'クレジットステータス',
  'profile.increaseCredit': 'クレジットを増やす',
  'profile.editCredit': 'クレジットの編集',
  'profile.employeeCredit': '従業員のクレジット',
  'profile.creditBalance': 'クレジット残高',
  'profile.myfavouritecity': '私の好きな都市',
  'profile.loan': 'ローン',
  'profile.gift': '贈り物',
  'profile.messageType': 'メッセージタイプ',
  'profile.text': 'テキスト',
  'profile.file': 'ファイル',
  'profile.totalPurchaseAmount': '合計購入金額',
  'profile.topCustomers': 'トップ顧客',
  'profile.homeAppliancesSeller': '家電販売者',
  'profile.pointsInventory': 'ポイントインベントリ',
  'profile.pointCard': 'ポイントカード',
  'profile.shoppingList': 'ショッピングリスト',
  'profile.customerInformation': '顧客情報',
  'profile.customerRegistrationDate': '顧客登録日',
  'profile.customerShoppingList': '顧客の買い物リスト',
  'profile.romaAirlines': 'Roma Airlines',
  'profile.incomeFromTheCustomer': '顧客からの収入',
  'profile.companyAddress': '会社の住所',
  'profile.nameOfCEO': 'CEOの名前',
  'profile.registration / priceChange': '登録/価格変更',
  'profile.printPassengerInvoice': '乗客の請求書を印刷',
  'profile.registrationPaymentReceipts': '支払い領収書の登録',
  'profile.priceToBuyFromOwner': 'ドニャロから購入する価格',
  'profile.salesPriceCustomer': '顧客への販売価格',
  'profile.salesManager': 'セールスマネージャー',
  'profile.showLess': '表示を少なくする',
  'profile.purchaseRate': '購入率',
  'profile.changeTicketSalesRates': 'チケット販売率の変更',
  'profile.savePrice': '価格を節約',
  'profile.remainingAmount': '残りの金額',
  'profile.firstPayment': '最初の支払い',
  'profile.settlementOfTickets': 'チケットの決済',
  'profile.totalAmount': '合計金額',
  'profile.attachedPaymentReceipt': '添付の支払い領収書',
  'profile.attachedPaymentReceipt1': '最初の添付された領収書',
  'profile.attachedPaymentReceipt2': '2番目の添付された領収書',
  'profile.attachedPaymentReceipt3': '3番目の添付された領収書',
  'profile.attachedPaymentReceipt4': '4番目の添付された領収書',
  'profile.attachedPaymentReceipt5': '5番目の添付された領収書',
  'profile.totalRemaining': '残りの合計',
  'profile.saveAndNextReceipt': '保存して次の領収書',
  'profile.saveAndExit': '保存して終了',
  'profile.travel': 'トラベル',
  'profile.editconfirmation':
    '編集リクエストを送信すると、Tripsiによって承認されるまでプロフィールが一時停止されます。 同意しますか？',
  'profile.searchtobuy': '検索して購入する比率',
  'profile.listOfPassengers': '乗客のリスト',
  'profile.me': 'Tell about yourself.Get points',
  'profile.customer': 'お客様 ',
  'profile.addcity': '都市を追加',
  'profile.showinfo': '情報を表示する',
  'profile.editPassengerInformation': '乗客情報の編集',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    '乗客は正常に登録されました',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    '要求された乗客情報は正常に編集されました',
  'profile.customerSuccessfullyRegistered': '顧客は正常に登録されました',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    '目的の顧客情報が正常に編集されました',
  'profile.addfriend': '友人を追加する',
  'profile.inveitefriend': '友達を招待',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    '乗客は正常に登録されました',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    '要求された乗客情報は正常に編集されました',
  'profile.customerSuccessfullyRegistered': '顧客は正常に登録されました',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    '目的の顧客情報が正常に編集されました',
  'profile.editEmployeeSuccessfully': '従業員を正常に編集しました',
  'profile.updateEmployeeSuccess': '従業員情報は正常に編集されました',
  'profile.mostSales': 'ほとんどの売上',
  'profile.theLowestNumberOfSales': '最低売上高',
  'profile.mostSalesAmount': 'ほとんどの売上高',
  'profile.theLowestSalesAmount': '最低販売額',
  'profile.mostActivityTime': 'ほとんどのアクティビティ時間',
  'profile.minimumActivityTime': '最小アクティビティ時間',
  'profile.employeeActivities': '従業員の活動',
  'profile.applyChanges': 'َّ変更を適用する',
  'profile.planPassenger': 'プランパッセンジャー',
  'profile.all': '全て',
  'profile.Activities': '活動',
  'profile.allProfiles': 'プロファイル',
  'profile.allStatuses': 'ステータス',
  'profile.dragtoadd': 'ドラッグして追加',
  'profile.dragtotransfer': 'ドラッグして転送',
  'profile.alltransactions': '全取引',
  'profile.changedate': '変更日',
  'profile.allusers': '全てのユーザー',
  'profile.recentTravels': '最近の旅行',
  'profile.mounthReport': '最近の月のパフォーマンス レポート',
  'profile.recentNews': '最近のニュース',
  'profile.tourismNews': '観光ニュース',
  'profile.donutChart': '行った旅行',
  'profile.recentMonthActivitie': '最近の月の活動',
  'profile.NumberFlightPurchases': '航空券購入回数',
  'profile.NumberFlightSearches': 'フライト検索数',
  'profile.agree': '同意',
  'profile.changeLogo': 'ロゴの変更',
  'profile.editingInformation': '編集情報',
  'profile.webSite': 'ウェブサイト',
  'profile.presensnt': '持続する',
  'profile.absence': '不在',
  'profile.leave': '離れる',
  'profile.inviteEmployees': '従業員を招待',
  'profile.textEditingTripsi':
    '以下のフォームからプロフィール情報を変更できます。変更後はTripsiによる承認のため、一時的に保留状態となります。',
  'profile.textEditingTripord':
    '以下のフォームからプロフィール情報を変更できます。変更後はTripordによる承認のため、一時的に保留状態となります。',
  'profile.textEmployees':
    '以下のフォームを使用して、退職した従業員に招待状を送信し、有効なユーザー名とコレクションに追加することができます。 .',
  'profile.addEmployees': '従業員を追加',
  'profile.textAddemplo':
    '以下のフォームを使用して、新しい従業員を会社に追加し、システムのさまざまな機能を通じて彼らのパフォーマンスを監視できます .',
  'profile.copy': 'コピーした',
  'profile.editEmployeeInformation': '従業員情報を編集する',
  'profile.purchases': '購入',
  'profile.addCustomer': '顧客を追加',
  'profile.textCustomer':
    '次のフォームから、次の情報を入力することで、希望する顧客をコレクションに追加できます。.',

  'profile.customerList': '顧客リスト',
  'profile.services': '私たちのサービス',
  'profile.tourManagement': 'ツアー管理',
  'profile.onlineFriend': '私のオンラインの友達',
  'profile.reservations': '予約',
  'profile.row': '行',
  'profile.transactions': '取引',
  'profile.searchHistory': '検索履歴',
  'profile.Transactions': '取引',
  'profile.Invoices': '請求書',
  'profile.assetManagment': '資産運用管理',
  'profile.transaction': '取引',
  'profile.Invoice': '請求書',
  'profile.Credit': 'クレジット',
  'profile.Invite': '招待',
  'profile.add': '追加',
  'profile.passengers': '乗客',
  'profile.messages': 'メッセージ',
  'profile.Services': 'サービス',
  'profile.messageNo': 'メッセージ番号',
  'profile.viewInvoice': '請求書を見る',
  'profile.flight': 'フライト',
  'profile.paid': '有料',
  'profile.unpaid': '未払い',
  'profile.choosefile': 'ファイルを選択',
  'profile.sellername': `名前の販売者`,
  'profile.factoreno': '因子番号',
  'profile.customername': '顧客名',
  'profile.phonenumber': '携帯電話番号',
  'profile.printinvoice': '請求書を印刷する',
  'profile.signature': '会計スタンプと署名',
  'profile.signaturetext': '印鑑・署名が無い場合は会計が無効となります。',
  'profile.servicedescription': 'サービスの説明',
  'profile.taxesduties': '税金と関税',
  'profile.purchaseamount': '購入金額',
  'profile.friendsearch': '名前、国番号、パスポート番号',
  'profile.ticketsearch': 'タイトル、チケット番号',
  'profile.messagesearch': '件名、メッセージ番号',
  'profile.bookingflightsearch': 'お名前、注文番号',
  'profile.transactionsearch': 'お名前、注文番号',
  'profile.employeesearch': '名前、メールアドレス',
  'profile.customersearch': '顧客名',
  'profile.passangersearch': '名前、国番号、パスポート番号',
  'profile.activities': '活動内容',
  'profile.addlicenselink': 'ライセンスの追加',
  'profile.startnewsevent': 'イベント開始',
  'profile.endnewsevent': '終了イベント',
  'profile.descriptionnews': 'ニュース本文 : ',
  'profile.introduction': '導入',
  'profile.firsttravel': '最初の旅行を待っています...',
  'profile.notfoundnews': '見つからないニュース',
  'profile.notfoundtravel': `あなたはまだ旅行したことがありません`,
  'profile.waitingTrip': '初めてのご旅行もお待ちしております。...',
  'profile.addLicenseText':
    '「以下のフォームを通じて、権限を入力し、最後に情報を登録できます。」',
  'profile.simpleuser': '一般ユーザー',
  'profile.owner': '所有者',
  'profile.crm': 'CRM',
  'profile.counter': 'カウンター',
  'profile.accountants': '会計士',
  'profile.roles': '役割',
  'profile.submitchangerate': '「販売率の変更が成功しました」',
  'profile.paymentprice': '支払い価格',
  'profile.savesuccessfully': 'プロフィールの保存が成功しました',
  'profile.viewfile': 'ファイルを表示します',
  'profile.backgammon': 'バックギャモン',
  'profile.chatgpt': 'チャットGPT',
  'profile.calendar': 'カレンダー',
  'profile.game': 'ゲーム',

  'profile.addgateway': 'フライトルートを追加',
  'profile.editgateway': 'フライトルートを編集',
  'profile.addgatewaydescription':
    'このフォームでは、希望のフライトルートを登録できます。登録後、検索は登録されたフライトルートに基づいて行われます',
  'profile.editgatewaydescription':
    'このフォームでは、希望のフライトルートを編集できます。編集後、検索は登録されたフライトルートに基づいて行われます',
  'profile.gatewayroutes': 'フライトルート',
  'profile.airlinecode': '航空会社コード',
  'profile.internalcode': '内部コード',
  'profile.weekdays': '曜日',
  'profile.known': '既知',
  'profile.unknown': '未知',
  'profile.airlinestatus': '航空会社の状態',
  'profile.allroutes': '全てのルート',
  'profile.selectoriginanddestination': '出発地と目的地',
  'profile.siti': 'シティ',
  'profile.sito': 'シト',
  'profile.soti': 'ソティ',
  'profile.soto': 'ソト',
  'profile.pathchoice': 'ルートの選択',
  'profile.submiteditgateway': 'ルートの編集を登録',
  'profile.submitaddgateway': 'フライトルートを登録',
  'profile.selectflightsdays': '飛行日を選択',
  'profile.departureflightcity': '出発都市',
  'profile.arrivalflightcity': '到着都市',
  'profile.ascinternalcode': '内部コードの昇順',
  'profile.descinternalcode': '内部コードの降順',
  'profile.ascairlinecode': '航空会社コードの昇順',
  'profile.descairlinecode': '航空会社コードの降順',
  'profile.addgatewaysuccessfully': 'フライトルートが正常に登録されました',
  'profile.editgatewaysuccessfully': 'フライトルートが正常に編集されました',
  'profile.notallowed': '承認する前にプロファイルを選択することはできません',
  'profile.addcustomerduplicated': '希望の顧客はすでに登録されています',
  'profile.sendfile': '銀行の領収書を送信',
  'profile.sendfiles': '銀行の領収書を送信',
  'profile.factorestartdate': '請求書の開始日',
  'profile.factoreenddate': '請求書の終了日',
  'profile.factoredate': '請求書の日付',
  'profile.allfactors': 'すべての請求書',
  'profile.walletnotenough': 'ウォレットの残高が不足しています',
  'profile.approvePrice': '承認価格',
  'profile.oldsecondpassword': '古い二次パスワード',
  'profile.setSecondPasswordInfo':
    '初めて二次パスワードを設定する場合、このフィールドを入力する必要はありません。',
};
